import { Controller } from '@hotwired/stimulus';

export default class extends Controller<HTMLElement> {
  static readonly targets = ['display', 'form'];
  static readonly values = { editing: Boolean };
  static readonly classes = ['hidden'];

  declare displayTargets: HTMLElement[];
  declare formTargets: HTMLFormElement[];
  declare hiddenClasses: string[];

  declare editingValue: boolean;

  initialize() {
    this.onToggle();
  }

  toggle() {
    this.editingValue = !this.editingValue;
    this.onToggle();
  }

  edit() {
    this.editingValue = true;
    this.onToggle();
  }

  display() {
    this.editingValue = false;
    this.onToggle();
  }

  private onToggle() {
    if (this.editingValue) {
      for (const target of this.displayTargets) {
        target.classList.add(this.hiddenClasses.join(' '));
        setElementDisabled(target, true);
      }
      for (const target of this.formTargets) {
        target.classList.remove(this.hiddenClasses.join(' '));
        setElementDisabled(target, false);
      }
    } else {
      for (const target of this.displayTargets) {
        target.classList.remove(this.hiddenClasses.join(' '));
        setElementDisabled(target, false);
      }

      for (const target of this.formTargets) {
        target.classList.add(this.hiddenClasses.join(' '));
        setElementDisabled(target, true);
      }
    }
  }
}

function isFieldset(element: HTMLElement) {
  return element instanceof HTMLFieldSetElement && element.type === 'fieldset';
}

function setElementDisabled(element: HTMLElement, value: boolean) {
  if (isFieldset(element)) {
    (element as HTMLFieldSetElement).disabled = value;
  }
}
